module.exports = {
    "collapse": `Sak\u{13C}aut`,
    "expand": `Izv\u{113}rst`
};


//# sourceMappingURL=lv-LV.main.js.map
